import { toCamelCase } from 'lib/helpers';
import './progressIndicator.scss';
import { useEffect, useState } from 'react';

const ProgressIndicator = ({ headline, inputName, unitType, initialValue, max }: ProgressIndicatorProps) => {
    const [progressValue, setProgressValue] = useState(initialValue || 0);
    let labelName
    if (inputName) {
        labelName = toCamelCase(inputName);
    }
    useEffect(() => {
        if (initialValue !== undefined) {
            setProgressValue(initialValue);
        }
    }, [initialValue]);

    const valueInPercent = Math.min(100, Math.round((progressValue / max) * 100));

    const barIndictorValuePositioning = "xsd-progress__bar-indicator-value msds-text-body-5 msds-text-clear-blue" +
        (valueInPercent > 95 ? " xsd-progress__bar-indicator-value--left" : ""); 

    return (
        <div className="xsd-progress msds-bg-gray-1">
            <div className="xsd-progress__headline msds-text-body-0-bold msds-text-gray-10">{headline}</div>
            <div className="xsd-progress__container">
                <label
                    className="xsd-progress__label msds-text-body-1"
                    htmlFor={labelName}>
                    {inputName}:
                </label>
                <div className="xsd-progress__bar-wrapper">
                    <div className="xsd-progress__bar-info">
                        <div className="msds-text-body-5 msds-text-gray-9">
                            0 {unitType}
                        </div>
                        <div className="msds-text-body-5 msds-text-gray-9">
                            {max} {unitType}
                        </div>
                    </div>
                    <progress
                        className="xsd-progress__bar"
                        id={labelName}
                        max={max}
                        value={progressValue} />
                    <div
                        className="xsd-progress__bar-indicator"
                        style={{ left: `${valueInPercent}%` }}
                    >
                        <div className={barIndictorValuePositioning}>
                            {initialValue} {unitType}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

type ProgressIndicatorProps = {
    headline: string,
    inputName: string,
    unitType: string,
    initialValue: number,
    max: number,
};


export default ProgressIndicator;